export default __webpack_public_path__ + "static/media/step8_img1.62ae8ed4.png";